require('./modal.js');

(function(){
  var mirror;

  Pegasus.WidgetCodeModal = Pegasus.Modal.extend({
    title: function(){
      return Em.I18n.t('instructions.enter_widget_html');
    }.property(),
    width: '750px',

    classNames: ['vr-collect-widget-code'],

    submitDisabled: false,
    cancelEnabled: false,
    hasFooter: true,

    didInsertElement: function(){
      mirror = CodeMirror.fromTextArea( this.get('view').$('textarea')[0], {
        lineNumbers: true,
        lineWrapping: true,
        theme: 'material',
        mode: 'htmlmixed'
      });

      mirror.on('focus', function(m){
        if ( m.getValue().trim() === this.get('defaultText') ) {
          m.setValue('');
        }
      }.bind(this));

      if ( ! mirror.getValue().trim() ) {
        mirror.setValue( this.get('defaultText') );
      }

      $(window).trigger('resize');
    },

    defaultText: function(){
      return Em.I18n.t('instructions.widget');
    }.property(),

    bodyTemplateName: 'modals/widget_code',

    headerClassName: 'editor-modal-header',
    bodyClassName: 'editor-modal-body',
    footerClassName: 'editor-modal-footer',

    didSubmit: function(){
      this.set('controller.presenter.content.contents', mirror.getValue());
      this.get('controller').set('presenter', null);
    },

    didCancel: function(){
      this.get('controller').set('presenter', null);
    }
  });
})();
